export default function () {
    return {
        reservation: {},
        availableStatus: []
    }
}
